import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery, Grid, Button, Typography } from '@material-ui/core';
import { Image } from 'components/atoms';
import { SectionHeader } from 'components/molecules';
import {Box} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  image: {
    boxShadow:
      '25px 60px 125px -25px rgba(80,102,144,.1), 16px 40px 75px -40px rgba(0,0,0,.2)',
    borderRadius: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      maxWidth: 500,
    },
  },
}));

const Alloseqtmt= props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box  className={className} {...rest} marginBottom={2} marginLeft= {2} marginRight={2} marginTop= {2} display="flex" justifyContent="space-evenly" alignItems="center" padding={5} border="1px solid #ccc" borderRadius="4px">
      <Grid
        container
        justify="space-between"
        spacing={4}
        direction={isMd ? 'row' : 'column-reverse'}
      >
        <Grid
          item
          container
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <SectionHeader
            title={
              <span>
       Hero headline
                <br />
                <Typography component="span" variant="inherit" color="primary">
                Alloseq TX 8
                </Typography>
              </span>
            }
            subtitle= " Alloseq Tx8 is the latest hybrid capture based NGS typing solution, it includes 6 classical HLA loci (A, B, C, DRB1, DQB1, DPB1) plus ABO and CCR5. It can go up to 384 samples in one run and automation friendly. It suits for the donor registry typing with fast turnaround time, cost saving and enhances volunteer donor registries for local & international requirements."
            
            align="left"
            disableGutter
            titleVariant="h3"
          />
          <ul>
            <li>
            Single tube workflow with 6 classical HLA loci plus ABO, CCR5
            </li>
            <li>
            NGS based, Utilizing Hybrid Capture Technology
            </li>
            <li>
            384 samples per run on MiSeq v3 Standard flowcell with data upload at 1 min/sample
            </li>
            <li>
            Less input DNA required less than 50ng
            </li>

          </ul>
          <SectionHeader
          
          ctaGroup={[
            <Button variant="contained" color="primary" size="large">
              Start now
            </Button>,
            <Button variant="outlined" color="primary" size="large">
              Learn more
            </Button>,
          ]}
          align="left"
          disableGutter
          titleVariant="h3"
          
          />
        </Grid>
        <Grid
          item
          container
          justify="flex-start"
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <Image
            src="https://ik.imagekit.io/j6phbjneuop/caredx/alloseghct_E0Q2w-vN8.png?updatedAt=1627465008708"
            alt="txt8"
            className={classes.image}
            data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

Alloseqtmt.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Alloseqtmt;
